import { Phone, Instagram, Facebook, ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0260B8] py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-14 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="font-heading font-black text-2xl tracking-tighter text-white mb-3">
              Vinylux
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Rénovation de cuisine par covering. Résultat haut de gamme sans travaux.
            </p>
          </div>

          <div>
            <div className="font-semibold text-xs text-white/70 uppercase tracking-widest mb-4">
              Services
            </div>
            <ul className="space-y-2.5 text-sm text-white/50">
              <li>Rénovation de cuisine</li>
              <li>Covering de façades</li>
              <li>Plans de travail</li>
              <li>Crédences & surfaces</li>
            </ul>
          </div>

          <div>
            <div className="font-semibold text-xs text-white/70 uppercase tracking-widest mb-4">
              Zone d'intervention
            </div>
            <ul className="space-y-2.5 text-sm text-white/50">
              <li><a href="/zones-intervention" className="hover:text-white transition-colors">Toutes les zones</a></li>
              <li><a href="/covering-cuisine-ain" className="hover:text-white transition-colors">Ain & Dombes</a></li>
              <li><a href="/covering-cuisine-lyon" className="hover:text-white transition-colors">Lyon & alentours</a></li>
              <li>Villefranche-sur-Saône</li>
            </ul>
          </div>

          <div>
            <div className="font-semibold text-xs text-white/70 uppercase tracking-widest mb-4">
              Contact
            </div>
            <div className="space-y-3">
              <a
                href="tel:+33695134999"
                data-testid="footer-phone"
                className="flex items-center gap-2.5 text-sm text-white/50 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4" />
                06 95 13 49 99
              </a>
              <a
                href="https://instagram.com/vinylux"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="flex items-center gap-2.5 text-sm text-white/50 hover:text-white transition-colors"
              >
                <Instagram className="w-4 h-4" />
                Instagram
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61590669930852"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="flex items-center gap-2.5 text-sm text-white/50 hover:text-white transition-colors"
              >
                <Facebook className="w-4 h-4" />
                Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} Vinylux. Tous droits réservés.
          </p>
          <button
            data-testid="scroll-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
          >
            <ArrowUp className="w-4 h-4 text-white/60" />
          </button>
        </div>
      </div>
    </footer>
  );
}
